import anime from 'animejs';
import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
  position: relative;
  width: 150px;
  height: 45px;
  text-align: center;
  background-color: transparent;
  color: #fff;
  font-family: Montserata, sans-serif;
  font-size: 1rem;
  font-weight: 800;
  :hover {
    cursor: pointer;
  }
  .lay {
    position: absolute;
    width: 0;
    height: 100%;
    left: 0.5px;
    background-color: #35a16d;
    border: 0 solid #35a16d;
    border-radius: 5px 5px 5px 5px;
  }
  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background-color: transparent;
    color: #fff;
    border: 2px solid #35a16d;
    border-radius: 5px;
    position: absolute;
    text-align: center;
    width: 100%;
    height: 100%;
  }
  span {
    display: flex;
    justify-content: center;
    margin: auto;
    a {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 10px;
    }
  }
`;

function StyledButton(props) {
  const { mClassName, label, link } = props;
  const animate = (width) => {
    const lay = document.querySelector(`.${mClassName} .lay`);
    anime({
      targets: lay,
      width: `${width}%`,
      easing: 'easeInOutExpo',
      duration: 300,
    });
  };

  return (
    <div className={`${mClassName}`}>
      <Button onMouseOver={() => animate(100)} onMouseLeave={() => animate(0)}>
        <div className="lay" />
        <div className="overlay">
          <span>
            {link
              ? <a href={`${link}`} target="_blank" rel="noreferrer">{`${label}`}</a>
              : `${label}`}
          </span>
        </div>
      </Button>
    </div>
  );
}

StyledButton.propTypes = {
  mClassName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
};

StyledButton.defaultProps = {
  link: '',
};

export default StyledButton;
